import { render, staticRenderFns } from "./BaseProspectus.vue?vue&type=template&id=1148863e&scoped=true&"
import script from "./BaseProspectus.js?vue&type=script&lang=js&"
export * from "./BaseProspectus.js?vue&type=script&lang=js&"
import style0 from "./BaseProspectus.vue?vue&type=style&index=0&id=1148863e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148863e",
  null
  
)

export default component.exports